import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { ProcessorService } from '@df/ng/processor.service';

/**
 * Local storage decorator.
 *
 * ```typescript
 * class someClass {
 *     @LocalStorage('someVariable')
 *     someProperty;
 * }
 * ```
 */
export function LocalStorage(key: string) {
    let service: LocalStorageService;
    const getService = (): LocalStorageService => {
        if (!service) {
            service = ProcessorService.injector.get(LocalStorageService);
        }
        return service;
    };
    return function (target: any, propertyKey: string | symbol) {
        Object.defineProperty(target, propertyKey, {
            get: () => getService().get(key),
            set: (value: any) => getService().set(key, value)
        });
    };
}
